import React from 'react';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: React.ReactNode;
  action?: { label: string; onClick: () => void };
  tone?: 'default' | 'error';
}

export function EmptyState({ icon, title, description, action, tone = 'default' }: EmptyStateProps) {
  return (
    <div className={tone === 'error' ? 'error-state' : 'empty'}>
      <div className="empty-icon">
        {icon || (
          <svg viewBox="0 0 32 32" width="30" height="30" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 10l12-6 12 6v12l-12 6-12-6V10z" />
            <path d="M4 10l12 6 12-6" />
            <path d="M16 28V16" />
          </svg>
        )}
      </div>
      <h3 className="empty-title">{title}</h3>
      {description && <p className="empty-desc">{description}</p>}
      {action && (
        <button className="btn btn-primary" onClick={action.onClick}>{action.label}</button>
      )}
    </div>
  );
}
